import { render, staticRenderFns } from "./MaterialDonationCreate.vue?vue&type=template&id=69d863fe&"
import script from "./MaterialDonationCreate.vue?vue&type=script&lang=js&"
export * from "./MaterialDonationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports